import { create } from 'superstruct'

import { LastRoomType, LastRoom } from './useLastRoom.types'

const LOCAL_STORAGE_KEY = 'WEVE_CONTENT_TOOLS:LAST_ROOM'

const storage = {
  get(): LastRoom | null {
    try {
      const data = localStorage.getItem(LOCAL_STORAGE_KEY)
      if (data === null) {
        return null
      }
      return create(JSON.parse(data), LastRoomType)
    } catch {
      return null
    }
  },
  set(value: LastRoom) {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(value))
    } catch {
      // do nothing
    }
  },
  reset() {
    try {
      localStorage.removeItem(LOCAL_STORAGE_KEY)
    } catch {
      // do nothing
    }
  },
}

export default storage
